import graphql__eebc3e0b599df39b3c3c from "./__generated__/DeleteSettlementDialog_settlement.graphql.ts";
import graphql__ffbbcc7e9ac140382135 from "./__generated__/DeleteSettlementDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useNavigate} from "react-router-dom";
import {FormattedDate, useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type DeleteSettlementDialogProps = {
    queryRef: any,
    handleCloseDialog: () => {}
}

const DeleteSettlementDialog: React.FC<DeleteSettlementDialogProps> = (props) => {

    const navigate = useNavigate();
    const intl = useIntl();
    const settlement = useFragment(
        graphql__eebc3e0b599df39b3c3c,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__ffbbcc7e9ac140382135,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                    new Promise(resolve => setTimeout(resolve, 3000)).then(() => navigate('/settlements'));
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToDeleteSettlement'})
            }
        )
    }

    const initialValues = {
        id: settlement.id
    }

    const settlementDate = intl.formatDate(settlement.cutOffAt, {month: 'long', year: 'numeric'});
    const settlementDisplay = `"${settlement.title.en}" for ${settlementDate}`;

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog}
                    handleSubmission={handleSubmission}
                    initialValues={initialValues}
                    headline={intl.formatMessage({id: 'dialog.DeleteSettlementDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'dialog.DeleteSettlementDialog.submitLabel'})}
                    dangerous={true}>
            <Section>
                <Row>
                    <p className="text-gray-900 font-medium">
                        {intl.formatMessage({id: 'dialog.DeleteSettlementDialog.confirmMessage'}, {id: settlementDisplay})}
                    </p>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default DeleteSettlementDialog;
